import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
// Service Worker / PWA retirado deliberadamente (offline no prioritario): la frescura de
// versión se garantiza vía index.html no-cache + bundles hasheados immutable + worker
// self-destruct en public/ngsw-worker.js. Ver OpenSpec change disable-pwa-service-worker.
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideToastr } from 'ngx-toastr';
import { createErrorHandler, TraceService } from '@sentry/angular';

import { routes } from './app.routes';
import { authInterceptorFn } from './core/auth/auth-interceptor.fn';
import { AuthService } from './core/auth/auth.service';

// Factory for translation loader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 4000,
      preventDuplicates: true,
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'es',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    // Sentry error handler: replaces Angular's default ErrorHandler globally.
    // showDialog: false — do not show Sentry's user feedback popup in production.
    { provide: ErrorHandler, useValue: createErrorHandler({ showDialog: false }) },
    // TraceService requires Router to track Angular Router navigations as Sentry transactions.
    { provide: TraceService, deps: [Router] },
    // APP_INITIALIZER forces DI to instantiate TraceService eagerly on app startup.
    { provide: APP_INITIALIZER, useFactory: () => () => {}, deps: [TraceService], multi: true },
    // Hydrate currentUser from /api/auth/me if a token is present. Fire-and-forget:
    // do not block initial render.
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => {
        auth.initializeFromStorage().subscribe();
      },
      deps: [AuthService],
      multi: true,
    },
  ]
};
